import { BrowserRouter, Routes, Route } from "react-router-dom";
import Toolbox from "./toolbox-react";
import InstagramViewer from "./instagram-viewer";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 메인 툴박스 (모든 계산기/변환기) */}
        <Route path="/*" element={<Toolbox />} />

        {/* 인스타그램 익명 뷰어 — 독립 페이지 */}
        <Route path="/instagram" element={<InstagramViewer />} />
      </Routes>
    </BrowserRouter>
  );
}
